<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage">
<a id="title64"></a>
<div class="p-c"><span><em class="i">To Ralph, for Ralph knows what and Ralph knows why</em></span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429936354_ded01.vue?d350e0ce